import { gql } from '@apollo/client';

// ✅ Get All Shared Emails
export const GET_SHARED_EMAILS = gql`
  query {
    getAllSharedEmails {
      _id
      email
      status
    }
  }
`;

// ✅ Create Shared Email
export const ADD_SHARED_EMAIL = gql`
  mutation createSharedEmail($email: String!) {
    createSharedEmail(email: $email) {
      status
      message
      emails {
        _id
        email
        status
      }
    }
  }
`;

// ✅ Update Shared Email
export const EDIT_SHARED_EMAIL = gql`
  mutation updateSharedEmail($id: ID!, $email: String, $status: Boolean) {
    updateSharedEmail(id: $id, email: $email, status: $status) {
      status
      message
      emails {
        _id
        email
        status
      }
    }
  }
`;

// ✅ Delete Shared Email by ID
export const DELETE_SHARED_EMAIL = gql`
  mutation deleteSharedEmail($id: ID!) {
    deleteSharedEmail(id: $id) {
      status
      message
      emails {
        _id
        email
        status
      }
    }
  }
`;
